import axios from 'axios'
import { EDITOR_NETWORK_TIMEOUT_MS } from '../constants/editorNetwork'
import wrappers from '../utils/wrappers'

const url = `${import.meta.env.VITE_API_URL}/v1/projects`

export default {
  create(params = {}) {
    return axios
      .post(url, params, { timeout: 5000 })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo crear el proyecto'),
      )
  },

  get(projectId: string) {
    return axios
      .get(`${url}/${projectId}`, { timeout: EDITOR_NETWORK_TIMEOUT_MS })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  getFull(projectId: string) {
    return axios
      .get(`${url}/${projectId}/full`, {
        // Must stay aligned with projects.getFull action timeout (120s).
        timeout: 120000,
        action: 'projects.getFull',
      })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  getEditorialStructure(projectId: string) {
    return axios
      .get(`${url}/${projectId}/editorial-structure`)
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo cargar la estructura editorial'),
      )
  },

  replaceEditorialStructure(projectId: string, elements: Array<{ type: string; data: Record<string, unknown> }>) {
    return axios
      .put(`${url}/${projectId}/editorial-structure`, { elements })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo guardar la estructura editorial'),
      )
  },

  stats(projectId: string) {
    return axios
      .get(`${url}/${projectId}/stats`)
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  dashboardPlanning(projectId: string, previewLimit = 5, todoPreviewLimit = previewLimit) {
    return axios
      .get(`${url}/${projectId}/dashboard/planning`, {
        params: { previewLimit, todoPreviewLimit },
        timeout: 5000,
      })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  dashboardReaderComments(projectId: string, previewLimit = 5) {
    return axios
      .get(`${url}/${projectId}/dashboard/reader-comments`, {
        params: { previewLimit },
        timeout: 5000,
      })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  dashboardManuscriptComments(projectId: string, previewLimit = 5) {
    return axios
      .get(`${url}/${projectId}/dashboard/manuscript-comments`, {
        params: { previewLimit },
        timeout: 5000,
      })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  userStats() {
    return axios
      .get(`${url}/user/stats`, { timeout: 5000 })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  list(params = {}, limit = 10, page = 1) {
    return axios
      .get(url, { params: { ...params, limit, page } })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  latest(params = {}) {
    return axios
      .get(`${url}/latest`, { params })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  addChapter(projectId: string, params = {}) {
    return axios
      .post(`${url}/${projectId}/chapter`, params, { timeout: 5000 })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo crear el capítulo'),
      )
  },

  listChapters(projectId: string) {
    return axios
      .get(`${url}/${projectId}/chapters`)
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
  },

  patch(projectId: string, params = {}) {
    return axios
      .patch(`${url}/${projectId}`, params)
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo editar el proyecto'),
      )
  },

  getAssetDownloadUrl(projectId: string, assetKey: string) {
    return axios
      .get(`${url}/${projectId}/assets/${assetKey}/download-url`, { timeout: 5000 })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo obtener la imagen completa'),
      )
  },

  delete(projectId: string) {
    return axios
      .delete(`${url}/${projectId}`)
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo eliminar el proyecto'),
      )
  },

  listDeleted(params = {}, limit = 50, page = 1) {
    return axios
      .get(`${url}/deleted`, { params: { ...params, limit, page } })
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo cargar la papelera'),
      )
  },

  restore(projectId: string) {
    return axios
      .post(`${url}/${projectId}/restore`)
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo restaurar el proyecto'),
      )
  },

  permanentDelete(projectId: string) {
    return axios
      .delete(`${url}/${projectId}/permanent`)
      .then((response: any) => wrappers.handleEscribonautaResponse(response))
      .catch((error: any) =>
        wrappers.handleEscribonautaError(error, 'No se pudo eliminar el proyecto permanentemente'),
      )
  },
}
